<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      title="Edit Data Persetujuan Karyawan"
      header-bg-variant="primary"
      header-text-variant="light"
      @show="showModal()"
    >
      <div
        style="
          text-align: center;
          padding: 2%;
          font-weight: 600;
          font-size: 21px;
        "
      >
        {{ data.nomorSurat }}
      </div>
      <b-form>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Data Karyawan <span class="text-danger">*</span>
          </template>
          <multiselect
            v-model="dataEdit.dataKaryawanIdEdit"
            :options="karyawan"
            :disabled="true"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="dataKaryawanId"
            label="dataKaryawan"
            placeholder="-- Pilih Karyawan --"
          ></multiselect>
        </b-form-group>

        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Tanggal Surat Dibuat <span class="text-danger">*</span>
          </template>
          <date-picker
            v-model="dataEdit.tanggalDibuatSurat"
            style="width: 100%"
            :placeholder="dataEdit.tanggalDibuatSuratEdit"
          ></date-picker>
        </b-form-group>

        <b-form-group label="Nama Mitra" label-cols-md="3">
          <multiselect
            v-model="dataEdit.mitraIdEdit"
            :options="mitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            track-by="id"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <!-- <b-form-group label-cols-md="3">
          <template v-slot:label>
            Durasi Kontrak (bulan) <span class="text-danger">*</span>
          </template>
          <b-form-input
            type="number"
            v-model="$v.data.masaBerlakuKontrak.$model"
            style="width: 100%"
          ></b-form-input>
        </b-form-group> -->

        <!-- <b-form-group label-cols-md="3">
          <template v-slot:label>
            Detail Persetujuan <span class="text-danger">*</span>
          </template>
          <b-form-textarea
            v-model="data.detail"
            style="width: 100%"
          ></b-form-textarea>
        </b-form-group> -->
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          Batal
        </b-button>
        <b-button
          variant="primary"
          @click="simpan()"
          :disabled="!isValid || busy"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
export default {
  components: { Multiselect, DatePicker },
  props: ["karyawan", "data", "mitra", "edit"],
  name: "modalInput",
  data() {
    return {
      dataEdit: {
        mitraIdEdit: "",
        koordinatorIdEdit: "",
        cabangIdEdit: "",
        capemIdEdit: "",
        dataKaryawanIdEdit: "",
        tanggalDibuatSurat: "",
      },
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataEdit, null, 4);
    },
    isValid() {
      return !this.$v.dataEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataEdit.$anyDirty;
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == 'super';
    },
  },
  mixins: [validationMixin],
  validations: {
    dataEdit: {
      dataKaryawanIdEdit: { required },
      tanggalDibuatSurat: { required },
      mitraIdEdit: { required },
      koordinatorIdEdit: {  },
      cabangIdEdit: {  },
      capemIdEdit: {  },
    },
  },
  watch: {
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataEdit[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async showModal(){
      const vm = this
      vm.busy = true;
      vm.dataEdit.tanggalDibuatSuratEdit = moment(vm.data.tanggalDibuatSurat).format("DD/MM/YYYY");
      for (let i = 0; i < vm.karyawan.length; i++) {
        if (vm.data.dataKaryawanId == vm.karyawan[i].dataKaryawanId) {
          vm.dataEdit.dataKaryawanIdEdit = vm.karyawan[i];
        }
      }
      for (let i = 0; i < vm.manajemen.length; i++) {
        if (vm.data.posisiManajemen == vm.manajemen[i].jabatanManajemen) {
          vm.data.posisiManajemenId = vm.manajemen[i];
        }
      }
      for (let i = 0; i < vm.listDivisi.length; i++) {
        const x = vm.listDivisi[i];
        if (x.masterDivisiId == vm.data.masterDivisiId) {
          vm.data.masterDivisiId = x;
          await vm.getPosisi(x)
        }
      }
      await vm.posisi.forEach((x) => {
        if (x.masterPosisiId == vm.data.masterPosisiId) {
          vm.data.masterPosisiId = x;
        }
      });
      for (let i = 0; i < vm.mitra.length; i++) {
        const x = vm.mitra[i];
        if (x.id == vm.data.mitraId) {
          vm.data.mitraId = x;
          await vm.getKoordinator(x)
        }
      }
      for (let i = 0; i < vm.koordinator.length; i++) {
        const x = vm.koordinator[i];
        if (x.koordinatorId == vm.data.koordinatorId) {
          vm.data.koordinatorId = x;
          await vm.getCabang(x)
        }
      }
      for (let i = 0; i < vm.cabang.length; i++) {
        const x = vm.cabang[i];
        if (x.cabangId == vm.data.cabangId) {
          vm.data.cabangId = x;
          await vm.getCapem(x)
        }
      }
      await vm.capem.forEach((x) => {
        if (x.capemId == vm.data.capemId) {
          vm.data.capemId = x;
        }
      });
    },
    async getKoordinator(x) {
      const vm = this
      if(x){
        let koordinator = await vm.$axios.get("/koordinator/listKoordinatorByMitraId/" + x.id);
        //   console.log(koordinator.data.data, "ini koordinator");
        this.koordinator = koordinator.data.data;
      }
    },
    async getCabang(x) {
      const vm = this
      if(x){
        let cabang = await vm.$axios.get("/cabang/listCabangByKoordinatorId/" + x.id);
        // console.log(cabang.data.data, "ini cabang");
        vm.cabang = cabang.data.data;
      }
    },
    async getCapem(x) {
      const vm = this
      if(x){
        let capem = await vm.$axios.get("/capem/listCapemByCabangId/" + x.id);
        //   console.log(cabang.data.data, "ini cabang");
        this.capem = capem.data.data;
      }
    },
    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.id = vm.data.suratPersetujuanId;
      vm.data.mitraId = vm.dataEdit.mitraIdEdit.id;
      vm.data.tanggalDibuatSurat = vm.dataEdit.tanggalDibuatSurat;
      vm.$axios
        .post("suratPersetujuan/update", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGUBAH KONTRAK KARYAWAN",
              showing: true,
            });
            this.$bvModal.hide("modal-edit");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: (res.data.message).tuUpperCase(),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
